import { take, call, put, fork } from 'redux-saga/effects';
import {
  fetchLoginState,
  failFetchingLoginState,
  fetchUser,
  failFetchingUser,
  login,
  clickLogout,
  logout,
  cancelOrder,
  externalSite,
  updateUser,
  failUpdateUser,
  successUpdateUser,
  updatePassword,
  reminderUpdatePassword,
  successReminderUpdatePassword,
} from '../actions/auth';
import { setData, resetData } from '../actions/user-data';
import { actions } from 'react-redux-form';
import superFetch from '../modules/superFetch';
import store from '../store/configureStore';
import form from '../reducers/form';
import {
  openSocket,
  externalLink,
  createUploadData,
  hasUnsyncedData,
} from '../modules/common';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';

// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleFetchLoginState() {
  while (true) {
    yield take(`${fetchLoginState}`);

    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      let global = store.getState().global;
      let forms = store.getState().forms;
      let userData = store.getState().userData;
      let application_type_flag;
      if (window.require) {
        application_type_flag = '1';
      } else {
        application_type_flag = '0';
      }

      let apiData = {};
      let requestType = 'GET';
      if (hasUnsyncedData(userData, forms)) {
        console.log('Unsynced data found during login state fetch.');
        const { updateData, uploadFlag } = createUploadData(
          userData,
          forms,
          null
        );
        if (uploadFlag) {
          apiData.unsyncedData = updateData;
          requestType = 'POST';
        }
      }

      const { payload, err } = yield call(superFetch, {
        url: '/api/login/index/' + global.item_id + '/' + application_type_flag,
        type: requestType,
        data: apiData,
        custom: {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        },
      });
      if (payload && !err) {
        //yield put(resetData());
        if (payload.userData) {
          if (payload.userData.setting) {
            let setting = payload.userData.setting;
            if (setting.global) {
              yield put(
                store.dispatch(actions.change('forms.global', setting.global))
              );
              yield put(
                store.dispatch(
                  actions.change('forms.prediction', setting.prediction)
                )
              );
              yield put(
                store.dispatch(
                  actions.change(
                    'forms.search',
                    Object.assign({}, forms.search, setting.resolve)
                  )
                )
              );
            } else {
              store.dispatch(actions.change('forms.global', setting));
            }
          }
          yield put(setData(payload.userData));
          payload.userData = null;
        }
        yield put(login(Object.assign({}, payload, { jwt })));
        continue;
      }
    }

    yield put(failFetchingLoginState());
  }
}

export function* handleExternalSite() {
  while (true) {
    const action = yield take(`${externalSite}`);
    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      const { payload, err } = yield call(superFetch, {
        url: '/api/auth/gettokenjwt',
        type: 'GET',
        custom: {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        },
      });
      if (payload && !err) {
        externalLink({
          url: action.payload.url + '?token=' + payload.token,
          blank: action.payload.blank,
        });
        continue;
      }
      externalLink({ url: action.payload.url, blank: action.payload.blank });
    } else {
      externalLink({ url: action.payload.url, blank: action.payload.blank });
    }

    yield put(failFetchingLoginState());
  }
}

export function* handleUpdateUser() {
  while (true) {
    const action = yield take(`${updateUser}`);
    const jwt = localStorage.getItem('jwt');

    const { payload, err } = yield call(superFetch, {
      url: '/api/customer/update',
      type: 'POST',
      data: action.payload,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });
    if (payload && !err) {
      yield put(successUpdateUser(payload));
      yield toast.success('登録情報を変更しました');
      yield put(push('/'));
      continue;
    }
    if (!payload && err) {
      yield put(failUpdateUser(String(err)));
      continue;
    }
  }
}

export function* handleUpdatePassword() {
  while (true) {
    const action = yield take(`${updatePassword}`);
    const jwt = localStorage.getItem('jwt');

    const { payload, err } = yield call(superFetch, {
      url: '/api/customer/password',
      type: 'POST',
      data: action.payload,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });
    if (payload && !err) {
      yield put(successUpdateUser(payload));
      yield toast.success('パスワードを変更しました');
      yield put(push('/'));
      continue;
    }
    if (!payload && err) {
      yield put(failUpdateUser(String(err)));
      continue;
    }
  }
}

export function* handleReminderUpdatePassword() {
  while (true) {
    const action = yield take(`${reminderUpdatePassword}`);
    const jwt = action.payload.jwt;

    const { payload, err } = yield call(superFetch, {
      url: '/api/customer/reminderpassword',
      type: 'POST',
      data: action.payload,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });
    if (payload && !err) {
      yield put(successReminderUpdatePassword());
      yield toast.success('パスワードを再設定しました。');
      yield put(push('/'));
      continue;
    }
    if (!payload && err) {
      yield put(failUpdateUser(String(err)));
      continue;
    }
  }
}

export function* handleFetchUser() {
  while (true) {
    const action = yield take(`${fetchUser}`);
    let global = store.getState().global;
    let forms = store.getState().forms;
    let userData = store.getState().userData;
    let application_type_flag;
    if (window.require) {
      application_type_flag = '1';
    } else {
      application_type_flag = '0';
    }

    let apiData = { ...action.payload };
    if (hasUnsyncedData(userData, forms)) {
      console.log('Unsynced data found during user fetch.');
      const { updateData, uploadFlag } = createUploadData(
        userData,
        forms,
        null
      );
      if (uploadFlag) {
        apiData.unsyncedData = updateData;
      }
    }

    const { payload, err } = yield call(superFetch, {
      url: '/api/login/index/' + global.item_id + '/' + application_type_flag,
      type: 'POST',
      data: apiData,
    });

    if (!payload && err) {
      yield put(failFetchingUser(String(err)));
      continue;
    }

    const jwt = payload.jwt;
    if (!window.ws) {
      openSocket(payload, global, true);
    } else {
      window.ws.send(
        JSON.stringify({ action: 'login', status: 'ok', email: payload.email })
      );
    }
    localStorage.setItem('jwt', jwt);
    if (payload.userData) {
      if (payload.userData.setting) {
        let setting = payload.userData.setting;
        if (setting.global) {
          yield put(
            store.dispatch(
              actions.change(
                'forms.global',
                Object.assign({}, setting.global, { loginNameDisplay: true })
              )
            )
          );
          yield put(
            store.dispatch(
              actions.change('forms.prediction', setting.prediction)
            )
          );
          yield put(
            store.dispatch(
              actions.change(
                'forms.search',
                Object.assign({}, forms.search, setting.resolve)
              )
            )
          );
        } else {
          yield put(store.dispatch(actions.change('forms.global', setting)));
        }
        payload.userData.setting = null;
      }
      yield put(setData(payload.userData));
      payload.userData = null;
    }

    yield put(login(Object.assign({}, payload, { jwt })));
  }
}

export function* handleLogout() {
  while (true) {
    yield take(`${clickLogout}`);

    localStorage.removeItem('jwt');
    if (window.ws) {
      window.ws.send(JSON.stringify({ action: 'logout', status: 'ok' }));
    }
    //yield put(resetData());
    //yield put(store.dispatch(actions.change('forms.global', form.global)));
    yield put(store.dispatch(actions.change('forms.search', form.search)));
    yield put(logout());
  }
}

export function* handleCancelOrder() {
  while (true) {
    yield take(`${cancelOrder}`);
    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      let global = store.getState().global;
      const { payload, err } = yield call(superFetch, {
        url: '/api/login/cancel/' + global.item_id,
        type: 'GET',
        custom: {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        },
      });
      if (payload && !err) {
        toast.success('クーリングオフを行いました');
        yield put(clickLogout());
      } else {
        toast.error(err.message);
      }
    }
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleFetchLoginState);
  yield fork(handleFetchUser);
  yield fork(handleLogout);
  yield fork(handleExternalSite);
  yield fork(handleCancelOrder);
  yield fork(handleUpdateUser);
  yield fork(handleUpdatePassword);
  yield fork(handleReminderUpdatePassword);
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js